/*
---
name: AmenitiesMap
description: New amenities map, hopefully alot more abstract and extensible.
authors:
- David Chan CK (http://www.reol.com)
- Kien Phong Vuong
license:
- MIT-style license
requires:
- core/1.2.4: '*'
- more/1.2.4.4: [Utilities.Assets]
- LazyLoader
- Remote
- GoogleMaps
provides: [AmenitiesMap]
...
*/
/**

AmenitiesMap
=========
Core AmenitiesMap Map. Extends GoogleMaps

Options
-------
+ _cls_ : The CSS class name for the widget
+ _ext_am_path_ : Path to External scripts used by this widget
**/
var AmenitiesMap = new Class
({
	Extends: GoogleMaps,
	Implements: [Options, Events],
	options:
	{
		cls: 'w_amenities',
		ext_am_path: null,
		has_base: true,
		add_lazy_load: true,
		secondary_dependencies: [
			'AmenitiesMap.Bubble'
		]
	},
/**

bound_overlays
----------
Update the zoom/bound of the map

###Arguments
+ _none_

**/
	bound_overlays: function()
	{
		this.parent();
		(function(){
			this.fireEvent('boundOverlays', this);
		}).delay(500, this);
	},
/**

build
----------
Sets up default attributes and load dependencies

###Arguments
+ _none_

**/
	build: function()
	{
		var opts = this.options,
				_self = $(this);
		this.am_loader;
		this.control_type;
		this.control_zoom;
		this.main_marker;
		this.place_markers = [];
		this.view; 
		this._controls = _self.getElement('.'+opts.cls+'_controls');

		if ($(this).getAttribute('data-fullscreencontrol')) {
			this.options.fullscreenControl = $(this).getAttribute('data-fullscreencontrol') == 'true';
		}

		if ($(this).getAttribute('data-zoomcontrol')) {
			this.options.zoomControl = $(this).getAttribute('data-zoomcontrol') == 'true';
		}

		if ($(this).getAttribute('data-maptypecontrol')) {
			this.options.mapTypeControl = $(this).getAttribute('data-maptypecontrol') == 'true';
		}

		this.parent();
	},
/**

create_view
----------
Setup view instance. (deprecated)

###Arguments
+ _none_

**/
	create_view: function(self)
	{
		Log.log('AmenitiesMap.create_view is deprecated. Please use options.callbacks.get_view');
		return new AmenitiesMap.View.Main(self, this.options.view_options);
	},
/**

init_dependencies
----------
Call methods to load specific dependencies.

###Arguments
+ _none_

**/
	init_dependencies: function()
	{
		this.fireEvent('initDependencies', this)
				.load_secondary_dependencies();
	},
/**

load_secondary_dependencies
----------
Load secondary depenencies used by this widget

###Arguments
+ _none_

**/
	load_secondary_dependencies: function()
	{
		var opts = this.options;

		this.am_loader = new LazyLoader.Multiple((opts.secondary_dependencies || this.get_secondary_dependencies()), {
			path: opts.ext_am_path
		});

		this.am_loader.addEvent('load', this.load_map_api.bind(this));
		return;
	},
/**

get_secondary_dependencies
----------
Get a losit of secondary depenencies used by this widget. (deprecated)

###Arguments
+ _none_

**/
	get_secondary_dependencies: function()
	{
		Log.log('AmenitiesMap.get_secondary_dependencies is deprecated. Please use options.callbacks.secondary_dependencies');
		return [
			'AmenitiesMap.Bubble'
		];
	},
/**

process_rpc
----------
Process RPC data

###Arguments
+ _none_

**/
	process_rpc: function()
	{
		var opts = this.options,
				data = this.main_remote.get_data(),
				data_base_location = data.base_location,
				main_latlng = new google.maps.LatLng(data.ini.lat, data.ini.lng),
				num_of_places = 0;

		data.categories.each(function(e){ num_of_places += e.places.length; });

		this.map.setCenter(main_latlng);

		this.markers_path = data.ini.markers_path;

		if(this.options.has_base == true){
			this.main_marker = new GoogleMaps.Marker(this, {
				lat: data_base_location.lat,
				lng: data_base_location.lng,
				icon: data.ini.markers_path + 'base.png'
			});

			this.markers.push(this.main_marker);
		}

		if(num_of_places > 0){
			this.view = opts.callbacks.get_view ? opts.callbacks.get_view(this) : new AmenitiesMap.View.Main(this, (opts.view_options || {}));
		}else{
			this.view = opts.callbacks.get_view(this, {fit_bounds: false});
			this.view._element.dispose();
		}

		this.fireEvent('processRPC', this);
	},

	set_center: function() {
		var data = this.main_remote.get_data();
		this.map.panTo(new google.maps.LatLng(data.ini.lat, data.ini.lng));
	},

	create_bubble_content: function(place){
		var cls = this.options.cls;
		var bubble;

		bubble	= '<div class="'+cls+'_overlay_pointer"></div>';
		bubble += '<div class="'+cls+'_overlay_content">';
		bubble +=	 '<div class="'+cls+'_overlay_info">';
		bubble +=			'<div class="name">';
		if(place.url){
			bubble +=			'<a href="'+place.url+'">';
		}
		bubble +=			 place.name;
		if(place.url){
			bubble +=			 '</a>';
		}
		bubble +=			'</div>';
		bubble +=		 '<div class="address">' + place.address + '</div>';

		bubble +=		 '<div class="description wysiwyg">'
		if(place.photo){
			bubble +=	 '<img src="' + place.photo + '" class="'+cls+'_overlay_photo"/>';
		}
		bubble +=		 place.description + '</div>';
		bubble +=	 '</div>';
		bubble += '</div>';

		return bubble;
	}

});
